import React, { Component } from 'react';
import { Modal, Button } from 'react-bootstrap';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import localForage from 'localforage';
import { actionCreators } from '../../../state/modals-dux';

import { reduxForm, Field, FormSection } from 'redux-form';
import FormField from '../../forms/FormField';

const NewRevisionFormComponent = props => {
  const { handleSubmit, pristine, reset, submitting, cancelEdit, showCancel } = props;
  return (
    <form onSubmit={handleSubmit}>
      <Field
        name="versionName"
        type="text"
        component={FormField.Input}
        label="Version Name"
        validate={value => value ? undefined : 'Required'}
      />
      {showCancel && (
        <Button type="button" bsStyle="hollow-info" disabled={submitting} onClick={cancelEdit}>
          <span className="ti ti-close" /> Cancel
        </Button>
      )}
      {' '}
      <Button bsStyle="success" type="submit" disabled={submitting}>
        <span className="ti ti-check" /> Submit
      </Button>
    </form>
  );
};

const NewRevisionForm = reduxForm({
  form: 'revision-form', // a unique identifier for this form
})(NewRevisionFormComponent);


class RevisionModal extends Component {
  constructor(props) {
    super(props);
    this.state = { submitNewRevision: false };
  }
  render() {
    const {
      openModal,
      closeModal,
      onRevisionSubmit,
      handleExistingRevisionSubmit,
      title,
      isEdit,
      showCancel,
      initialValues,
      name
    } = this.props;

    const { submitNewRevision } = this.state;
    const handleCloseModal = () => {
      this.setState({ submitNewRevision: false });
      closeModal();
    }
    const setNewRevision = () => {
      this.setState({ submitNewRevision: true });
    }
    const handleSubmit = next => data => {
      this.setState({ submitNewRevision: false });
      closeModal();
      next(data);
    }
    return (
      <Modal show={openModal === name} onHide={handleCloseModal}>
        <Modal.Header closeButton>
          <Modal.Title>{title || 'Revision'}</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {isEdit && (
            <div>
              {!submitNewRevision && (
                <div>
                  <h4>Would you like to create a new version or update existing?</h4>
                  <Button bsStyle="hollow-info" onClick={handleSubmit(handleExistingRevisionSubmit)}>
                    Update Existing
                  </Button>
                  {' '}
                  <Button bsStyle="success" onClick={setNewRevision}>
                    New Version
                  </Button>
                </div>
              )}
              {submitNewRevision && (
                <NewRevisionForm
                  onSubmit={handleSubmit(onRevisionSubmit)}
                />
              )}
            </div>
          )}
          {!isEdit && (
            <NewRevisionForm
              showCancel={showCancel}
              onSubmit={handleSubmit(onRevisionSubmit)}
              initialValues={initialValues || {}}
              cancelEdit={handleCloseModal}
            />
          )}

        </Modal.Body>
      </Modal>
    )
  }
}


const mapState = state => ({ openModal: state.modals });
const mapDispatch = dispatch => bindActionCreators(actionCreators, dispatch);

export default connect(mapState, mapDispatch)(RevisionModal);



// WEBPACK FOOTER //
// ./src/components/routes/assets/RevisionModal.js